module.exports = __webpack_public_path__ + "static/img/science2.72ea8878.png";